/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Accreditation_Professionalcriteriatitle2Inputs */

const en_welcome_accreditation_professionalcriteriatitle2 = /** @type {(inputs: Welcome_Accreditation_Professionalcriteriatitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional Criteria`)
};

/**
* | output |
* | --- |
* | "Professional Criteria" |
*
* @param {Welcome_Accreditation_Professionalcriteriatitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_accreditation_professionalcriteriatitle2 = /** @type {((inputs?: Welcome_Accreditation_Professionalcriteriatitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Accreditation_Professionalcriteriatitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_accreditation_professionalcriteriatitle2(inputs)
});
export { welcome_accreditation_professionalcriteriatitle2 as "welcome_accreditation_professionalCriteriaTitle" }